export default __webpack_public_path__ + "static/media/Smartcryptologo.662221b7.svg";